import React from 'react';
//import { Header, Hero, HowItWorks, AvailablePlans, InteractiveCircleDemo, Footer, DynamicSavings, SectionTransition,TransformYourSavings } from '../components/HomePage';
import { Header, Hero, TransformYourSavings, AvailablePlans, InteractiveCircleDemo, 
  Footer, DynamicSavings } from '../components/HomePage';

  function HomePage() {
    return (
      <>
        <Header />
        <Hero />
        <AvailablePlans />
        <TransformYourSavings /> {/* This will use your TransformYourSavings component */}
        <DynamicSavings />
        <Footer />
      </>
    );
  }

export default HomePage;

